const configuration = {

    baseUrl: process.env.REACT_APP_BASEURL,
    testing: process.env.REACT_APP_TESTING === "true",
    appEnv: process.env.REACT_APP_ENV || "unknown env",
    debug: process.env.REACT_APP_DEBUG === "true",
    version: "2.6.27.1"

}
export default configuration;